import { render } from "./AccountMenuComponent.vue?vue&type=template&id=5644d0d6"
import script from "./AccountMenuComponent.vue?vue&type=script&lang=js"
export * from "./AccountMenuComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/frontend/account/AccountMenuComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5644d0d6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5644d0d6', __exports__)) {
    api.reload('5644d0d6', __exports__)
  }
  
  module.hot.accept("./AccountMenuComponent.vue?vue&type=template&id=5644d0d6", () => {
    api.rerender('5644d0d6', render)
  })

}


export default __exports__